import type { IProduct } from '../api/domain';
import { Tenant } from '../enum/tenant';

export enum CardArts {
    DEBIT_MAESTRO = 2,
    DEBIT_CARD_WIR = 3,
    DEBIT_CARD_12 = 12,
    FIRST_CREDIT_CARD = 400,
    LAST_CREDIT_CARD = 599,
    DEBIT_MASTERCARD = 930,
    DEBIT_WIR = 931,
    DEBIT_VISA = 940,
}

const debitCardArts = [CardArts.DEBIT_MAESTRO, CardArts.DEBIT_CARD_12, CardArts.DEBIT_MASTERCARD, CardArts.DEBIT_VISA];
const debitCardArtsWir = [...debitCardArts, CardArts.DEBIT_WIR, CardArts.DEBIT_CARD_WIR];

export const DEFAULT_DEBIT_CARD_FINNOVA_CODE = CardArts.DEBIT_MASTERCARD;

export const isDebitCardArt = (tenant: Tenant, cardArt: number) => (tenant === Tenant.WIR ? debitCardArtsWir : debitCardArts).includes(cardArt);

export const isCreditCardArt = (tenant: Tenant, cardArt: number) => cardArt >= CardArts.FIRST_CREDIT_CARD && cardArt <= CardArts.LAST_CREDIT_CARD;

export const isCardArt = (tenant: Tenant, cardArt: number) => isDebitCardArt(tenant, cardArt) || isCreditCardArt(tenant, cardArt);

export const isDebitCard = (tenant: Tenant, card: IProduct) => card.finnovaId && isDebitCardArt(tenant, parseInt(card.finnovaId, 10));

export const isCreditCard = (tenant: Tenant, card: IProduct) => card.finnovaId && isCreditCardArt(tenant, parseInt(card.finnovaId, 10));

export const sortByPriorityPredicate = <T extends { priority: number }>(e1: T, e2: T) => e1.priority - e2.priority;
